import { Paper } from '@mui/material';
import MonthSelector from './MonthSelector';
import useStyles from './Calendar.styles';
import DayHeader from './DayHeader';
import CalendarContent from './CalendarContent';
import useCalendarContext from './CalendarContext';

const Calendar = (): JSX.Element => {
  const classes = useStyles();
  const { disabled } = useCalendarContext();

  return (
    <Paper className={classes.container}>
      <MonthSelector />

      <table className={classes.calendar}>
        <tbody>
          <DayHeader />

          <CalendarContent />
        </tbody>
      </table>

      {disabled && <div className={classes.mask} />}
    </Paper>
  );
};

export default Calendar;
